import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_68275efa from 'nuxt_plugin_plugin_68275efa' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_a31d0246 from 'nuxt_plugin_sentryserver_a31d0246' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_48b80d55 from 'nuxt_plugin_sentryclient_48b80d55' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_axios_74b8e819 from 'nuxt_plugin_axios_74b8e819' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_pluginrouting_7b40600d from 'nuxt_plugin_pluginrouting_7b40600d' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_b59b62fc from 'nuxt_plugin_pluginmain_b59b62fc' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_4b7935c1 from 'nuxt_plugin_cookieuniversalnuxt_4b7935c1' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_nuxtsvgsprite_27fb9012 from 'nuxt_plugin_nuxtsvgsprite_27fb9012' // Source: ./nuxt-svg-sprite.js (mode: 'all')
import nuxt_plugin_dayjsplugin_d1275ab8 from 'nuxt_plugin_dayjsplugin_d1275ab8' // Source: ./dayjs-plugin.js (mode: 'all')
import nuxt_plugin_vuetour_59b5b321 from 'nuxt_plugin_vuetour_59b5b321' // Source: ../src/plugins/vue-tour.js (mode: 'all')
import nuxt_plugin_vuescrolllock_303bf52a from 'nuxt_plugin_vuescrolllock_303bf52a' // Source: ../src/plugins/vue-scroll-lock.js (mode: 'all')
import nuxt_plugin_lazysizes_5f3274f0 from 'nuxt_plugin_lazysizes_5f3274f0' // Source: ../src/plugins/lazysizes.js (mode: 'all')
import nuxt_plugin_socketioclient_92193ae4 from 'nuxt_plugin_socketioclient_92193ae4' // Source: ../src/plugins/socketio.client.js (mode: 'client')
import nuxt_plugin_utils_1f62007d from 'nuxt_plugin_utils_1f62007d' // Source: ../src/plugins/utils.js (mode: 'all')
import nuxt_plugin_analytics_60d673f0 from 'nuxt_plugin_analytics_60d673f0' // Source: ../src/plugins/analytics.js (mode: 'client')
import nuxt_plugin_intercom_06bd687b from 'nuxt_plugin_intercom_06bd687b' // Source: ../src/plugins/intercom.js (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    return this.$root.$options.$nuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"__dangerouslyDisableSanitizers":["script"],"title":"Discontract Business Central","htmlAttrs":{"lang":"lt"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"script":[{"innerHTML":"(function(){var w=window;var ic=w.Intercom;if(typeof ic===\"function\"){ic('reattach_activator');ic('update',w.intercomSettings);}else{var d=document;var i=function(){i.c(arguments);};i.q=[];i.c=function(args){i.q.push(args);};w.Intercom=i;var l=function(){var s=d.createElement('script');s.type='text\u002Fjavascript';s.async=true;s.src='https:\u002F\u002Fwidget.intercom.io\u002Fwidget\u002Fnrzl1o5k';var x=d.getElementsByTagName('script')[0];x.parentNode.insertBefore(s,x);};if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();","type":"text\u002Fjavascript","charset":"utf-8"}],"style":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_68275efa === 'function') {
    await nuxt_plugin_plugin_68275efa(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_a31d0246 === 'function') {
    await nuxt_plugin_sentryserver_a31d0246(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_48b80d55 === 'function') {
    await nuxt_plugin_sentryclient_48b80d55(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_74b8e819 === 'function') {
    await nuxt_plugin_axios_74b8e819(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_7b40600d === 'function') {
    await nuxt_plugin_pluginrouting_7b40600d(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_b59b62fc === 'function') {
    await nuxt_plugin_pluginmain_b59b62fc(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_4b7935c1 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_4b7935c1(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtsvgsprite_27fb9012 === 'function') {
    await nuxt_plugin_nuxtsvgsprite_27fb9012(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjsplugin_d1275ab8 === 'function') {
    await nuxt_plugin_dayjsplugin_d1275ab8(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetour_59b5b321 === 'function') {
    await nuxt_plugin_vuetour_59b5b321(app.context, inject)
  }

  if (typeof nuxt_plugin_vuescrolllock_303bf52a === 'function') {
    await nuxt_plugin_vuescrolllock_303bf52a(app.context, inject)
  }

  if (typeof nuxt_plugin_lazysizes_5f3274f0 === 'function') {
    await nuxt_plugin_lazysizes_5f3274f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_socketioclient_92193ae4 === 'function') {
    await nuxt_plugin_socketioclient_92193ae4(app.context, inject)
  }

  if (typeof nuxt_plugin_utils_1f62007d === 'function') {
    await nuxt_plugin_utils_1f62007d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_analytics_60d673f0 === 'function') {
    await nuxt_plugin_analytics_60d673f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_intercom_06bd687b === 'function') {
    await nuxt_plugin_intercom_06bd687b(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
